export const dsbpConstant = {
  xml_tooltip_value:
    "Awaiting response from RTA to share the COPY XML. Upload task will be sent to Agencies after this request is completed.",
  xml_awaiting_response_enovia: "POA Update in progress. Awaiting response from Enovia",
  xml_awaiting_response: "awaiting response",
  xml_view_changes_btn: "View changes",
  xml_Fail_response: "FAIL",
  xml_Error_response: "Error",
  xml_Success_response: "Success",
  xml_view_changes: "View changes!",
  xml_locked: "LOCKED",
  not_cic: "You cannot apply the CIC Matrix to the selected PMPs because at least one them has been defined as: CIC needed = Not needed or CIC dependent.",
  not_cic_msg: "Please review the selected PMPs and ensure that all are set to CIC needed = Select or Yes before proceeding with the addition of the CIC Matrix.",
  fullkit_not_ready:
    "Fullkit for all/part of PMPs you have selected is not ready. Please verify your selection",
  cic_request_sent:
    "CIC request for all/part of the PMPs already sent. Please verify your selection",
  cic_request_sent_no_cic:
    "Either CIC/CIC Matrix Request is alreday sent or the selected PMPs are not a CIC. Please verify your selection.",
  cic_matrix_added:
    "One or more PMPs are part of an existing CIC Matrix, please review your selection and try again.",
  unknown_operation: "Unknown operation",
  requestedCicAcknowledgementHeader: "CIC/CIC Matrix requested",
  requestedCicAcknowledgementSuccessMessage: `Automated Copy XML request is in progress. Once it's completed, the "Upload CIC/CIC Matrix" task will be sent. 
    It should be done within 15 minutes.`,
  requestedCicAcknowledgementErrorMessage:
    "Automated Copy XML request was not accepted by RTA, CIC will not be requested. Please try again, if problem persists, please open a ticket",
  fromActionFullkitNotReadyMessage:
    "Fullkit is not ready for the CIC/CIC Matrix. Please verify and try again.",
  fromActionNoPMPMessage: "No PMPs are Locked in DSBP",
  requestCICandCICMatrix: "Request CIC/CIC Matrix Upload",
  cicTooltipMessage:
    "When CIC needed = CIC Dependent, Complete at least one of: 'Supporting PMP layout,' 'Supporting PMP design,' or 'Other reference' before submitting.",
  deleteCicMatrixMessage: "Are you sure you want to remove this CIC from CIC Matrix?",
  addToProjectDisabledMessage:
    "Please review the CIC mapping and remove the association of the PMP with CIC /CIC Matrix before you can change the selection of 'Add to Project'.",
  CIC_NEEDED: "CIC Needed",
  SUPPORTING_PMP_LAYOUT: "Supporting PMP Layout",
  SUPPORTING_PMP_DESIGN: "Supporting PMP Design",
  OTHER_REFERENCE: "Other Reference",
  GA_BRIEF: "GA Brief",
  massUpdateCICMappingMessage: "The dependency has been automatically set to 'None' and will need to update it if a different mapping is required.",
  groupCICMatrixMessage: "The default setup is CIC Matrix only. If you need individual CICs to follow the CIC Matrix, please apply the necessary setup in the 'AWM CIC Matrix (optional)' column.",
  DT_NONE: [
    {
      AWM_Design_Job_ID: "DT_None",
      AWM_Design_Job_Name: "None",
      Design_Job_Status: "None",
    },
  ],
  IQ_NONE: [
    {
      AWM_Design_Job_ID: "IQ_None",
      AWM_Design_Job_Name: "None",
      Design_Job_Status: "None",
    },
  ],
  NPF_NONE: [
    {
      AWM_Design_Job_ID: "NPF_None",
      AWM_Design_Job_Name: "None",
      Design_Job_Status: "None",
    },
  ]
};
export const artworkAction=[
  {
    value: "Mass Update",
    key: "option-1",
    header: "Mass Update",
  },
  {
    value: "Create POAA",
    key: "option-2",
    header: "Are you sure you want to create POAs for below PMPs in RTA ?",
  },
  {
    value: "Group PMPs",
    key: "option-3",
    header: "Are you sure you want to group these PMPs ?",
  },
  {
    value: "Add to Project",
    key: "option-4",
    header: "Are you sure you want to add these PMP to Project ?",
  },
  {
    value: "Recreate POA",
    key: "option-5",
    header: "Recreating POA will cancel and recreate all AWM tasks including CIC/CIC Matrix related to this POA and remove it from Mappings. Please inform Dependency Mapping task owner if required. Do you want to continue?",
  },
];
export const dependencyAction=[
  {
    value: "Group items into CIC Matrix",
    key: "option-1",
    header: "Are you sure you want to link these PMPs to CIC Matrix ?",
  },
  {
    value: "Request CIC/CIC Matrix Upload",
    key: "option-2",
    header: "Please confirm you want to request CIC/CIC Matrix for following CICs?",
  },
  {
    value: "Mass Update CIC Mapping",
    key: "option-3",
    header: "Mass Update CIC Mapping",
  },
];